// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckoutSlider_wrapper__VvezW","preview":"CheckoutSlider_preview__wibe6"};